module.exports = __webpack_public_path__ + "static/ecf43660-b213-4e09-8d49-932a2b985bcb-original.31b9f3b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/st-michael-and-all-angels/ecf43660-b213-4e09-8d49-932a2b985bcb-original.jpg
// module id = 1191
// module chunks = 168707334958949